import React from 'react';

export function CreateBookingCurrentIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4917 2.16406H6.50841C3.47508 2.16406 1.66675 3.9724 1.66675 7.00573V13.9807C1.66675 17.0224 3.47508 18.8307 6.50841 18.8307H13.4834C16.5167 18.8307 18.3251 17.0224 18.3251 13.9891V7.00573C18.3334 3.9724 16.5251 2.16406 13.4917 2.16406ZM9.12508 15.0891C8.88341 15.3307 8.42508 15.5641 8.09175 15.6141L6.04175 15.9057C5.96675 15.9141 5.89175 15.9224 5.81675 15.9224C5.47508 15.9224 5.15841 15.8057 4.93341 15.5807C4.65841 15.3057 4.54175 14.9057 4.60841 14.4641L4.90008 12.4141C4.95008 12.0724 5.17508 11.6224 5.42508 11.3807L9.14175 7.66406C9.20841 7.83906 9.27508 8.01406 9.36675 8.21406C9.45008 8.38906 9.54175 8.5724 9.64175 8.73906C9.72508 8.88073 9.81675 9.01406 9.89175 9.11406C9.98341 9.25573 10.0917 9.38906 10.1584 9.46406C10.2001 9.5224 10.2334 9.56406 10.2501 9.58073C10.4584 9.83073 10.7001 10.0641 10.9084 10.2391C10.9667 10.2974 11.0001 10.3307 11.0167 10.3391C11.1417 10.4391 11.2667 10.5391 11.3751 10.6141C11.5084 10.7141 11.6417 10.8057 11.7834 10.8807C11.9501 10.9807 12.1334 11.0724 12.3167 11.1641C12.5084 11.2474 12.6834 11.3224 12.8584 11.3807L9.12508 15.0891ZM14.4751 9.73906L13.7084 10.5141C13.6584 10.5641 13.5917 10.5891 13.5251 10.5891C13.5001 10.5891 13.4667 10.5891 13.4501 10.5807C11.7584 10.0974 10.4084 8.7474 9.92508 7.05573C9.90008 6.96406 9.92508 6.86406 9.99175 6.80573L10.7667 6.03073C12.0334 4.76406 13.2417 4.78906 14.4834 6.03073C15.1167 6.66406 15.4251 7.2724 15.4251 7.90573C15.4167 8.50573 15.1084 9.10573 14.4751 9.73906Z"
        fill="#2179C4"
      />
    </svg>
  );
}
export function CreateBookingCompletedIcon() {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99984 0.171875C4.40817 0.171875 0.666504 3.91354 0.666504 8.50521C0.666504 13.0969 4.40817 16.8385 8.99984 16.8385C13.5915 16.8385 17.3332 13.0969 17.3332 8.50521C17.3332 3.91354 13.5915 0.171875 8.99984 0.171875ZM12.9832 6.58854L8.25817 11.3135C8.1415 11.4302 7.98317 11.4969 7.8165 11.4969C7.64984 11.4969 7.4915 11.4302 7.37484 11.3135L5.0165 8.95521C4.77484 8.71354 4.77484 8.31354 5.0165 8.07187C5.25817 7.83021 5.65817 7.83021 5.89984 8.07187L7.8165 9.98854L12.0998 5.70521C12.3415 5.46354 12.7415 5.46354 12.9832 5.70521C13.2248 5.94688 13.2248 6.33854 12.9832 6.58854Z"
        fill="#55B938"
      />
    </svg>
  );
}
export function CreateBookingDisabledIcon() {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1834 0.905208C12.7834 0.505208 11.9834 0.171875 11.4167 0.171875H6.58342C6.01675 0.171875 5.21675 0.505208 4.81675 0.905208L1.40008 4.32188C1.00008 4.72187 0.666748 5.52188 0.666748 6.08854V10.9219C0.666748 11.4885 1.00008 12.2885 1.40008 12.6885L2.67508 13.9635L14.4584 2.18021L13.1834 0.905208Z"
        fill="#C9C9C9"
      />
      <path
        d="M16.6003 4.32083L15.3419 3.0625L3.55859 14.8458L4.81693 16.1042C5.21693 16.5042 6.01693 16.8375 6.58359 16.8375H11.4169C11.9836 16.8375 12.7836 16.5042 13.1836 16.1042L16.6003 12.6875C17.0003 12.2875 17.3336 11.4875 17.3336 10.9208V6.0875C17.3336 5.52083 17.0003 4.72083 16.6003 4.32083Z"
        fill="#C9C9C9"
      />
    </svg>
  );
}
export function CreateBookingPendingIcon() {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99984 0.164062C4.40817 0.164062 0.666504 3.90573 0.666504 8.4974C0.666504 13.0891 4.40817 16.8307 8.99984 16.8307C13.5915 16.8307 17.3332 13.0891 17.3332 8.4974C17.3332 3.90573 13.5915 0.164062 8.99984 0.164062ZM12.6248 11.4724C12.5082 11.6724 12.2998 11.7807 12.0832 11.7807C11.9748 11.7807 11.8665 11.7557 11.7665 11.6891L9.18317 10.1474C8.5415 9.76406 8.0665 8.9224 8.0665 8.18073V4.76406C8.0665 4.4224 8.34984 4.13906 8.6915 4.13906C9.03317 4.13906 9.3165 4.4224 9.3165 4.76406V8.18073C9.3165 8.48073 9.5665 8.9224 9.82484 9.0724L12.4082 10.6141C12.7082 10.7891 12.8082 11.1724 12.6248 11.4724Z"
        fill="#F2C94C"
      />
    </svg>
  );
}
export function CreateBookingWarningIcon() {
  return (
    <svg
      width="1.25vw"
      height="1.25vw"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4916 13.5583L11.1249 10.5H8.86657L5.4999 13.5583C4.55823 14.4083 4.2499 15.7167 4.70823 16.9C5.16657 18.075 6.28323 18.8333 7.54157 18.8333H12.4499C13.7166 18.8333 14.8249 18.075 15.2832 16.9C15.7416 15.7167 15.4332 14.4083 14.4916 13.5583ZM11.5166 15.6167H8.48323C8.16657 15.6167 7.91657 15.3583 7.91657 15.05C7.91657 14.7417 8.1749 14.4833 8.48323 14.4833H11.5166C11.8332 14.4833 12.0832 14.7417 12.0832 15.05C12.0832 15.3583 11.8249 15.6167 11.5166 15.6167Z"
        fill="#F29C4C"
      />
      <path
        d="M15.2919 4.0974C14.8335 2.9224 13.7169 2.16406 12.4585 2.16406H7.54188C6.28355 2.16406 5.16688 2.9224 4.70855 4.0974C4.25855 5.28073 4.56688 6.58906 5.50855 7.43906L8.87521 10.4974H11.1335L14.5002 7.43906C15.4335 6.58906 15.7419 5.28073 15.2919 4.0974ZM11.5169 6.5224H8.48355C8.16688 6.5224 7.91688 6.26406 7.91688 5.95573C7.91688 5.6474 8.17522 5.38906 8.48355 5.38906H11.5169C11.8335 5.38906 12.0835 5.6474 12.0835 5.95573C12.0835 6.26406 11.8252 6.5224 11.5169 6.5224Z"
        fill="#F29C4C"
      />
    </svg>
  );
}
export function BolAWBBLIcon() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.47162 10.75C4.76162 10.75 4.04162 10.49 3.49162 9.96C1.65162 8.21 0.91162 6.3 1.34162 4.43C1.85162 2.23 3.78162 1.25 5.47162 1.25C7.16162 1.25 9.10162 2.24 9.60162 4.43C10.0316 6.3 9.28162 8.21 7.45162 9.96C6.90162 10.49 6.19162 10.75 5.47162 10.75ZM2.80162 4.77C2.42162 6.44 3.53162 7.92 4.53162 8.87C5.06162 9.38 5.89162 9.37 6.42162 8.87C7.42162 7.92 8.53162 6.44 8.14162 4.76C7.80162 3.28 6.49162 2.75 5.48162 2.75C4.46162 2.75 3.15162 3.28 2.80162 4.77Z"
        fill="#395C85"
      />
      <path
        d="M5.51172 6.2002C4.96172 6.2002 4.51172 5.7502 4.51172 5.2002C4.51172 4.6502 4.95172 4.2002 5.51172 4.2002H5.52172C6.07172 4.2002 6.52172 4.6502 6.52172 5.2002C6.52172 5.7502 6.07172 6.2002 5.51172 6.2002Z"
        fill="#395C85"
      />
      <path
        d="M18.4913 22.7502C17.7813 22.7502 17.0613 22.4902 16.5013 21.9602C14.6513 20.2102 13.9013 18.3002 14.3413 16.4202C14.8513 14.2302 16.7913 13.2402 18.4913 13.2402C20.1913 13.2402 22.1313 14.2302 22.6413 16.4202C23.0713 18.2902 22.3213 20.2102 20.4713 21.9502C19.9213 22.4902 19.2113 22.7502 18.4913 22.7502ZM18.4913 14.7502C17.4713 14.7502 16.1513 15.2802 15.8013 16.7702C15.4113 18.4402 16.5313 19.9302 17.5313 20.8802C18.0613 21.3902 18.9013 21.3902 19.4413 20.8802C20.4413 19.9302 21.5613 18.4502 21.1713 16.7802C20.8413 15.2802 19.5213 14.7502 18.4913 14.7502Z"
        fill="#395C85"
      />
      <path
        d="M18.5312 18.2002C17.9812 18.2002 17.5312 17.7502 17.5312 17.2002C17.5312 16.6502 17.9712 16.2002 18.5312 16.2002H18.5413C19.0913 16.2002 19.5413 16.6502 19.5413 17.2002C19.5413 17.7502 19.0812 18.2002 18.5312 18.2002Z"
        fill="#395C85"
      />
      <path
        d="M12.0014 19.75H9.32141C8.16141 19.75 7.15141 19.05 6.75141 17.97C6.34141 16.89 6.64141 15.7 7.51141 14.93L15.5014 7.94C15.9814 7.52 15.9914 6.95 15.8514 6.56C15.7014 6.17 15.3214 5.75 14.6814 5.75H12.0014C11.5914 5.75 11.2514 5.41 11.2514 5C11.2514 4.59 11.5914 4.25 12.0014 4.25H14.6814C15.8414 4.25 16.8514 4.95 17.2514 6.03C17.6614 7.11 17.3614 8.3 16.4914 9.07L8.50141 16.06C8.02141 16.48 8.01141 17.05 8.15141 17.44C8.30141 17.83 8.68141 18.25 9.32141 18.25H12.0014C12.4114 18.25 12.7514 18.59 12.7514 19C12.7514 19.41 12.4114 19.75 12.0014 19.75Z"
        fill="#395C85"
      />
      <path
        d="M12.0014 19.75H9.32141C8.16141 19.75 7.15141 19.05 6.75141 17.97C6.34141 16.89 6.64141 15.7 7.51141 14.93L15.5014 7.94C15.9814 7.52 15.9914 6.95 15.8514 6.56C15.7014 6.17 15.3214 5.75 14.6814 5.75H12.0014C11.5914 5.75 11.2514 5.41 11.2514 5C11.2514 4.59 11.5914 4.25 12.0014 4.25H14.6814C15.8414 4.25 16.8514 4.95 17.2514 6.03C17.6614 7.11 17.3614 8.3 16.4914 9.07L8.50141 16.06C8.02141 16.48 8.01141 17.05 8.15141 17.44C8.30141 17.83 8.68141 18.25 9.32141 18.25H12.0014C12.4114 18.25 12.7514 18.59 12.7514 19C12.7514 19.41 12.4114 19.75 12.0014 19.75Z"
        fill="#395C85"
      />
    </svg>
  );
}
export function TrackingLinkIcon() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.98969 21.5001C7.32969 21.5001 5.65969 20.8701 4.38969 19.6001C1.85969 17.0601 1.85969 12.9401 4.38969 10.4101C4.67969 10.1201 5.15969 10.1201 5.44969 10.4101C5.73969 10.7001 5.73969 11.1801 5.44969 11.4701C3.49969 13.4201 3.49969 16.5901 5.44969 18.5401C7.39969 20.4901 10.5697 20.4901 12.5197 18.5401C13.4597 17.6001 13.9797 16.3401 13.9797 15.0001C13.9797 13.6701 13.4597 12.4101 12.5197 11.4601C12.2297 11.1701 12.2297 10.6901 12.5197 10.4001C12.8097 10.1101 13.2897 10.1101 13.5797 10.4001C14.8097 11.6301 15.4797 13.2601 15.4797 15.0001C15.4797 16.7401 14.7997 18.3701 13.5797 19.6001C12.3197 20.8701 10.6597 21.5001 8.98969 21.5001Z"
        fill="#395C85"
      />
      <path
        d="M19.0681 14.1602C18.8781 14.1602 18.6881 14.0902 18.5381 13.9402C18.2481 13.6502 18.2481 13.1702 18.5381 12.8802C20.5881 10.8302 20.5881 7.50023 18.5381 5.46023C16.4881 3.41023 13.1581 3.41023 11.1181 5.46023C10.1281 6.45023 9.57812 7.77023 9.57812 9.17023C9.57812 10.5702 10.1281 11.8902 11.1181 12.8802C11.4081 13.1702 11.4081 13.6502 11.1181 13.9402C10.8281 14.2302 10.3481 14.2302 10.0581 13.9402C8.78813 12.6702 8.07812 10.9702 8.07812 9.17023C8.07812 7.37023 8.77813 5.67023 10.0581 4.40023C12.6881 1.77023 16.9681 1.77023 19.6081 4.40023C22.2381 7.03023 22.2381 11.3202 19.6081 13.9502C19.4581 14.0902 19.2581 14.1602 19.0681 14.1602Z"
        fill="#395C85"
      />
    </svg>
  );
}
